import React from 'react';
import { motion } from 'motion/react';
import { Github, Twitter, Linkedin, Mail } from 'lucide-react';
import PotredPathDrawing from './PotredPathDrawing.jsx';
import PotredStroke from './PotredStroke.jsx';

const Footer = ({ navigation = [], ghostPages = [], siteMaintenancePages = [], categories = [], siteTitle = 'Potred', siteDescription = '' }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="site-footer" className="bg-white/90 dark:bg-slate-950/90 backdrop-blur-md border-t border-gray-200/50 dark:border-slate-800/50 mt-20">
      <div className="max-w-7xl mx-auto px-8 sm:px-16 lg:px-32 xl:px-36 py-12">
        <div className="footer-grid" style={{
          display: 'grid',
          gridTemplateColumns: window.innerWidth >= 768 ? '2fr 1fr 1fr' : '1fr',
          gap: '2rem'
        }}>
          {/* Brand Section - Spans 2 columns on desktop */}
          <div id="footer-brand" className="footer-brand-section">
            <a href="/" className="inline-flex items-center gap-2 mb-4">
              <motion.div
                whileHover={{ scale: 1.1 }}
                transition={{ duration: 0.3 }}
              >
                <PotredPathDrawing 
                  className="w-8 h-8 text-orange-600 dark:text-orange-600"
                  enablePeriodicAnimation={true}
                  animateOnMount={false}
                />
              </motion.div>
              <div className="w-32 h-8 sm:w-36 sm:h-9 flex items-center">
                <PotredStroke 
                  text="Potred"
                  className="text-orange-600 dark:text-orange-400"
                  stroke={2}
                  duration={2.2}
                  size="medium"
                  responsive={true}
                />
              </div>
            </a>
            <p className="text-gray-600 dark:text-gray-300 mb-6 max-w-md leading-relaxed">
              {siteDescription || 'Discover the latest insights in web development, design trends, and technology innovations. Join our community of developers and creators building the future of the web.'}
            </p>
            
            {/* Social Links */}
            <div id="footer-social" className="flex gap-4">
              {/* GitHub, Twitter, LinkedIn temporarily hidden until setup */}
              {/* 
              <motion.a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-gray-100 dark:bg-slate-800 hover:bg-gray-200 dark:hover:bg-slate-700 transition-colors duration-200 relative overflow-hidden"
                whileHover={{
                  scale: [null, 1.1, 1.6],
                  transition: {
                    duration: 0.3,
                    times: [0, 0.6, 1],
                    ease: ["easeInOut", "easeOut"],
                  },
                }}
                whileTap={{ scale: 0.95 }}
                transition={{
                  duration: 0.3,
                  ease: "easeOut",
                }}
              >
                <Github className="w-5 h-5 text-orange-600 dark:text-orange-400 relative z-10" />
                
                <motion.div
                  className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-400 to-transparent opacity-0"
                  style={{ background: 'linear-gradient(90deg, transparent, #ff8904, transparent)' }}
                  initial={{ opacity: 0, x: '-100%' }}
                  whileHover={{
                    opacity: [0, 0.5, 0],
                    x: ['100%', '100%', '200%'],
                    transition: {
                      duration: 0.3,
                      times: [0, 0.5, 1],
                      ease: "easeOut",
                    },
                  }}
                />
              </motion.a>
              <motion.a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-gray-100 dark:bg-slate-800 hover:bg-gray-200 dark:hover:bg-slate-700 transition-colors duration-200 relative overflow-hidden"
                whileHover={{
                  scale: [null, 1.1, 1.6],
                  transition: {
                    duration: 0.3,
                    times: [0, 0.6, 1],
                    ease: ["easeInOut", "easeOut"],
                  },
                }}
                whileTap={{ scale: 0.95 }}
                transition={{
                  duration: 0.3,
                  ease: "easeOut",
                }}
              >
                <Twitter className="w-5 h-5 text-orange-600 dark:text-orange-400 relative z-10" />
                
                <motion.div
                  className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-400 to-transparent opacity-0"
                  style={{ background: 'linear-gradient(90deg, transparent, #ff8904, transparent)' }}
                  initial={{ opacity: 0, x: '-100%' }}
                  whileHover={{
                    opacity: [0, 0.5, 0],
                    x: ['100%', '100%', '200%'],
                    transition: {
                      duration: 0.3,
                      times: [0, 0.5, 1],
                      ease: "easeOut",
                    },
                  }}
                />
              </motion.a>
              <motion.a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-gray-100 dark:bg-slate-800 hover:bg-gray-200 dark:hover:bg-slate-700 transition-colors duration-200 relative overflow-hidden"
                whileHover={{
                  scale: [null, 1.1, 1.6],
                  transition: {
                    duration: 0.3,
                    times: [0, 0.6, 1],
                    ease: ["easeInOut", "easeOut"],
                  },
                }}
                whileTap={{ scale: 0.95 }}
                transition={{
                  duration: 0.3,
                  ease: "easeOut",
                }}
              >
                <Linkedin className="w-5 h-5 text-orange-600 dark:text-orange-400 relative z-10" />
                
                <motion.div
                  className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-400 to-transparent opacity-0"
                  style={{ background: 'linear-gradient(90deg, transparent, #ff8904, transparent)' }}
                  initial={{ opacity: 0, x: '-100%' }}
                  whileHover={{
                    opacity: [0, 0.5, 0],
                    x: ['100%', '100%', '200%'],
                    transition: {
                      duration: 0.3,
                      times: [0, 0.5, 1],
                      ease: "easeOut",
                    },
                  }}
                />
              </motion.a>
              */}
              <motion.a
                href="mailto:hello@potred.com"
                className="p-2 rounded-lg bg-gray-100 dark:bg-slate-800 hover:bg-gray-200 dark:hover:bg-slate-700 transition-colors duration-200 relative overflow-hidden"
                whileHover={{
                  scale: [null, 1.1, 1.6],
                  transition: {
                    duration: 0.3,
                    times: [0, 0.6, 1],
                    ease: ["easeInOut", "easeOut"],
                  },
                }}
                whileTap={{ scale: 0.95 }}
                transition={{
                  duration: 0.3,
                  ease: "easeOut",
                }}
              >
                <Mail className="w-5 h-5 text-orange-600 dark:text-orange-400 relative z-10" />
                
                {/* Orange Glare/Flash Effect */}
                <motion.div
                  className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-400 to-transparent opacity-0"
                  style={{ background: 'linear-gradient(90deg, transparent, #ff8904, transparent)' }}
                  initial={{ opacity: 0, x: '-100%' }}
                  whileHover={{
                    opacity: [0, 0.5, 0],
                    x: ['100%', '100%', '200%'],
                    transition: {
                      duration: 0.3,
                      times: [0, 0.5, 1],
                      ease: "easeOut",
                    },
                  }}
                />
              </motion.a>
            </div>
          </div>

          {/* Quick Links - Center column */}
          <div id="footer-quick-links">
            <h4 className="text-lg font-semibold text-orange-600 dark:text-orange-400 mb-4 font-iansui">
              Quick Links
            </h4>
            <nav className="space-y-3">
              {ghostPages.map((page, index) => (
                <a
                  key={index}
                  href={page.url}
                  className="block text-gray-600 dark:text-gray-300 hover:text-orange-600 dark:hover:text-orange-400 transition-colors"
                >
                  {page.title}
                </a>
              ))}
              {siteMaintenancePages.map((page, index) => (
                <a
                  key={`maintenance-${index}`}
                  href={page.url}
                  className="block text-gray-600 dark:text-gray-300 hover:text-orange-600 dark:hover:text-orange-400 transition-colors"
                >
                  {page.title}
                </a>
              ))}
            </nav>
          </div>

          {/* Categories - Right column */}
          <div id="footer-categories">
            <h4 className="text-lg font-semibold text-orange-600 dark:text-orange-400 mb-4 font-iansui">
              Categories
            </h4>
            <nav className="space-y-3">
              {categories.filter(category => category.name.toLowerCase() !== 'site maintenance').map((category, index) => (
                <a
                  key={index}
                  href={`/tag/${category.slug}/`}
                  className="block text-gray-600 dark:text-gray-300 hover:text-orange-600 dark:hover:text-orange-400 transition-colors"
                >
                  {category.name}
                </a>
              ))}
            </nav>
          </div>
        </div>

        {/* Bottom Bar */}
        <div id="footer-bottom" className="mt-12 pt-8 border-t border-gray-200 dark:border-slate-700">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-600 dark:text-gray-300 text-sm font-iansui">
              © {currentYear} Potred. All rights reserved.
            </div>
            <div className="flex space-x-6 text-sm">
              {/* Privacy Policy and Terms links removed - available in footer navigation */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;